import React from 'react';

import { gold } from '@ant-design/colors';
import { ExclamationCircleTwoTone as AntdWarningIcon } from '@ant-design/icons/lib/icons';
import { Tooltip as AntdTooltip } from 'antd';

import { ConfigurationDto } from 'lib_api/lib/api/gen';

import { useModal } from 'hooks/modal/useModal';

import ModalModification from '../Modals/ModalModification/ModalModification';

import './CellParsingError.less';

interface CellParsingErrorProps {
  configuration: ConfigurationDto;
}
function CellParsingError({
  configuration,
}: CellParsingErrorProps): React.ReactElement {
  const antdWarningColor = gold.primary;
  const modalModification = useModal(false);

  return (
    <>
      <AntdTooltip
        title={configuration.parsingError}
        overlayStyle={{ cursor: 'pointer' }}
      >
        <AntdWarningIcon
          twoToneColor={antdWarningColor}
          className="parsingErrorIcon"
          onClick={modalModification.open}
        />
      </AntdTooltip>
      <ModalModification
        configuration={configuration}
        visible={modalModification.visible}
        close={modalModification.close}
      />
    </>
  );
}

export default CellParsingError;
